const ServiceNowIcon = ():JSX.Element => {
    return (
<svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_8133_144112)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M12.0844 0C5.4346 0 0 5.5 0 12.3145C0 15.7044 1.35021 18.9906 3.78059 21.3082C4.62447 22.1384 5.94093 22.2075 6.88608 21.4811C9.92405 19.1635 14.1097 19.1635 17.1477 21.4811C18.0928 22.2075 19.4093 22.1384 20.2532 21.3082C25.0802 16.6038 25.2827 8.78616 20.692 3.83962C18.4641 1.41824 15.3249 0.0345912 12.0844 0ZM12.0169 18.5063C8.77637 18.6101 6.07595 15.9811 6.00844 12.695C6.00844 12.5912 6.00844 12.4874 6.00844 12.3836C6.00844 8.99371 8.70886 6.22642 12.0169 6.22642C15.3249 6.22642 18.0253 8.99371 18.0253 12.3836C18.1266 15.7044 15.5612 18.4371 12.3544 18.5409C12.2194 18.5063 12.1181 18.5063 12.0169 18.5063Z" fill="#62D84E"/>
</g>
<defs>
<clipPath id="clip0_8133_144112">
<rect width="24" height="22" fill="white"/>
</clipPath>
</defs>
</svg>
)
}
export default ServiceNowIcon